// extracted by mini-css-extract-plugin
export var container = "index-module--container--RDVmY";
export var content = "index-module--content--xvVjm";